"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMediaPlayerCacheManagerDispatch = exports.IMediaPlayerDispatch = void 0;
const native_rtc_1 = require("@iris/native-rtc");
const AgoraConsole_1 = require("../util/AgoraConsole");
class IMediaPlayerDispatch {
    constructor(engine) {
        this._engine = engine;
    }
    // @ts-ignore
    getMediaPlayerId() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getMediaPlayerId not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    open_e43f201(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_open_e43f201 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    openWithMediaSource_3c11499(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_openWithMediaSource_3c11499 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    play() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_play not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    pause() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_pause not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stop() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_stop not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    resume() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_resume not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    seek_f631116(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_seek_f631116 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAudioPitch_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setAudioPitch_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getDuration_b12f121(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getDuration_b12f121 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getPlayPosition_b12f121(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getPlayPosition_b12f121 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getStreamCount_b12f121(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getStreamCount_b12f121 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getStreamInfo_0fa63fa(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getStreamInfo_0fa63fa not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLoopCount_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setLoopCount_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setPlaybackSpeed_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setPlaybackSpeed_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    selectAudioTrack_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_selectAudioTrack_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    selectMultiAudioTrack_4e92b3c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_selectMultiAudioTrack_4e92b3c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setPlayerOption_4d05d29(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setPlayerOption_4d05d29 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setPlayerOption_ccad422(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setPlayerOption_ccad422 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    takeScreenshot_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_takeScreenshot_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    selectInternalSubtitle_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_selectInternalSubtitle_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setExternalSubtitle_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setExternalSubtitle_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getState() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getState not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    mute_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_mute_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getMute_c93e9d4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getMute_c93e9d4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustPlayoutVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_adjustPlayoutVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getPlayoutVolume_9cfaa7e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getPlayoutVolume_9cfaa7e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustPublishSignalVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_adjustPublishSignalVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getPublishSignalVolume_9cfaa7e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getPublishSignalVolume_9cfaa7e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setView_cb1a81f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setView_cb1a81f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRenderMode_bedb5ae(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setRenderMode_bedb5ae not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerPlayerSourceObserver_15621d7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_registerPlayerSourceObserver_15621d7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    unregisterPlayerSourceObserver_15621d7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_unregisterPlayerSourceObserver_15621d7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerAudioFrameObserver_89ab9b5(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_registerAudioFrameObserver_89ab9b5 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerAudioFrameObserver_a5b510b(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_registerAudioFrameObserver_a5b510b not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    unregisterAudioFrameObserver_89ab9b5(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_unregisterAudioFrameObserver_89ab9b5 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerVideoFrameObserver_833bd8d(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_registerVideoFrameObserver_833bd8d not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    unregisterVideoFrameObserver_5165d4c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_unregisterVideoFrameObserver_5165d4c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerMediaPlayerAudioSpectrumObserver_226bb48(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_registerMediaPlayerAudioSpectrumObserver_226bb48 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    unregisterMediaPlayerAudioSpectrumObserver_09064ce(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_unregisterMediaPlayerAudioSpectrumObserver_09064ce not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAudioDualMonoMode_30c9672(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setAudioDualMonoMode_30c9672 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getPlayerSdkVersion() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getPlayerSdkVersion not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getPlaySrc() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getPlaySrc not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    openWithAgoraCDNSrc_e43f201(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_openWithAgoraCDNSrc_e43f201 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getAgoraCDNLineCount() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getAgoraCDNLineCount not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    switchAgoraCDNLineByIndex_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_switchAgoraCDNLineByIndex_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getCurrentAgoraCDNIndex() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_getCurrentAgoraCDNIndex not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableAutoSwitchAgoraCDN_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_enableAutoSwitchAgoraCDN_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    renewAgoraCDNSrcToken_e43f201(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_renewAgoraCDNSrcToken_e43f201 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    switchAgoraCDNSrc_7a174df(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_switchAgoraCDNSrc_7a174df not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    switchSrc_7a174df(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_switchSrc_7a174df not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    preloadSrc_e43f201(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_preloadSrc_e43f201 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    playPreloadedSrc_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_playPreloadedSrc_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    unloadSrc_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_unloadSrc_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSpatialAudioParams_5035667(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setSpatialAudioParams_5035667 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSoundPositionParams_f282d50(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayer_setSoundPositionParams_f282d50 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IMediaPlayerDispatch = IMediaPlayerDispatch;
class IMediaPlayerCacheManagerDispatch {
    constructor(engine) {
        this._engine = engine;
    }
    // @ts-ignore
    removeAllCaches() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_removeAllCaches not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    removeOldCache() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_removeOldCache not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    removeCacheByUri_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_removeCacheByUri_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setCacheDir_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_setCacheDir_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setMaxCacheFileCount_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_setMaxCacheFileCount_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setMaxCacheFileSize_f631116(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_setMaxCacheFileSize_f631116 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableAutoRemoveCache_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_enableAutoRemoveCache_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getCacheDir_c9551e8(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_getCacheDir_c9551e8 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getMaxCacheFileCount() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_getMaxCacheFileCount not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getMaxCacheFileSize() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_getMaxCacheFileSize not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getCacheFileCount() {
        AgoraConsole_1.AgoraConsole.warn('MediaPlayerCacheManager_getCacheFileCount not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IMediaPlayerCacheManagerDispatch = IMediaPlayerCacheManagerDispatch;
